module.exports = __webpack_public_path__ + "static/media/kake_brown-min.8c1ac64b.png";